/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-undef */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React,{ useState, useEffect} from "react";
import PropTypes from 'prop-types';
import { connect,useSelector } from 'react-redux';
// import { encode } from "base-64";
// import Modal from 'react-bootstrap/Modal';
// import './App.css';
import { useHistory, Link  } from 'react-router-dom';
import Moment from 'moment';
// import styles from '../../pages/ProjectMaster/ProjectMaster.module.css';
// import styles from '../../cssModules/TableMaster.module.css'
// import {CustomFormGroup1} from '../FormComponents/CustomFormGroup';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableSimple from "../../atomicComponents/TableSimple/TableSimple";
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import Table from "../Table/Table";
import useAjaxCallbackWithIntervals from '../../hooks/useAjaxCallbackWithIntervals';
import { API } from '../../apis/api';
import { buildErrorMessage } from '../../apis/calls';
import styles from './BookingHrsTable.module.css';

// import { API_RESOURCE_URLS, BASE_URL } from '../../constants';
// import { Button, TabWithCount} from '../../atomicComponents';
// import { useSelector } from 'react-redux';


const HrsTable = () => {

    const data=[{"id":123,"Ticket":1654765, "Name":'ABC',"Hrs":'20hrs'}]
//   const authToken = useSelector(state => state.auth.authToken);
//     const history = useHistory();
//     const [dataArray, setDataArray] = useState([]);
//     // const [postdata, setPostData] = useState({});
//     const token = `bearer ${authToken}`
//             // const token = `bearer  ${authToken}`
//             // const token = 'bearer  12345bGOisdfJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJYbXZPeklGOUJsaFkyQ1dHZnd6a2NJNEROeDlWdFoxMmJYX292WEN5cXQ4In0.eyJleHAiOjE2NTU5NTg1MDIsImlhdCI6MTY1NTk1ODMyMiwiYXV0aF90aW1lIjoxNjU1OTU3Mzc1LCJqdGkiOiI3YWQ4ZTkzZS02ODE2LTRiN2ItYjI3Yi1jMThiOTIzNTAzMTEiLCJpc3MiOiJodHRwczovL2F1dGguZXAtZGV2LnRhdGFtb3RvcnMuY29tL2F1dGgvcmVhbG1zL2VudGVycHJpc2UiLCJzdWIiOiJlZGUyNWE0Mi0wYjZkLTQ5MDMtYTJkMi0wNTEwMWZkMmNjMGEiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJwbGFubmluZyIsIm5vbmNlIjoiZDg3MDc5NmItYTc3MS00ZGNmLWFjYWMtZmM0YjFhMjJkNzEwIiwic2Vzc2lvbl9zdGF0ZSI6IjkxZmFiNjgwLTM3NjUtNDQ4My04ZTU1LTQ0OWMyNWU4OWRiNSIsImFjciI6IjAiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9wbGFubmluZy5lcC1kZXYudGF0YW1vdG9ycy5jb20iLCJodHRwczovL3Byb2R1Y3Rpb24tbWFzdGVyLWRhdGEuZXAtZGV2LnRhdGFtb3RvcnMuY29tIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwgcGxhbm5pbmciLCJhcHBsaWNhdGlvbl9hY2Nlc3MiOnsiYXBwbGljYXRpb25zIjoicHBjLHNjbSxxdWFsaXR5LHBwYXAsbWFpbnRlbmFuY2UscmVjb25jaWxpYXRpb24ifSwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJjb21tb24iOnsiZnVuY3Rpb25zIjoiZGV2ZWxvcGVyIn0sIm9yZyI6InRtbCIsIm5hbWUiOiJEZXZlbG9wZXIgRGV2ZWxvcGVyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidG1sZGV2IiwiZ2l2ZW5fbmFtZSI6IkRldmVsb3BlciIsImZhbWlseV9uYW1lIjoiRGV2ZWxvcGVyIiwiZW1haWwiOiJ0bWxkZXZAc2FoYWouYWkifQ.b5TNJCI7q3evdyJfninbNpuksCRbyyktp5LdCAGA6JsONqnOgIlZy6i9roGnQN0pR2rPdkr7zgJvSAHalmOJ_GHYqMZmbbm56m3OBA-C-LeGU6XfB5baqdEfOanNumHE2KRaPX0HO6AR3yvsX4Sc76aobqRNqioBlZOfxOBU44LK54k502fRege3ghf2YpenFv-2Gf4YYMH__BxkoYgoGkw5xIS4E_bWitl-nqtz0RXOc1Chm8eg57bOka92uIHVDPSYRkuLXIrPH_hbgfdurOy_q8VNtP7FGsetcCjPs3xQyW37MapDDmJ_3RkUUg5OI9-swIA8w915uY7Lvxt1fQ'
//             const username = 'B06400k01';
//             const password = '123';
//             const headerss = new Headers();
            

//             headerss.append("authorization", token, encode(username, ":", password));
//             // headerss.append("username", userName);
//             // headerss.append("Email", email)
//             headerss.append('Content-Type', 'application/json');

//              const fetchData = () => {
//                 fetch(`${BASE_URL}/supplier_actionplan`, {
//                     method: 'GET',
//                     headers: headerss,
//                     // body: JSON.stringify({ "username": userName, "Email": email }),
                    
//                 }).then((response) => response.json())
//                 .then((response) => {
//                 console.log('test',response);
//                 setDataArray(response);
//                 // console.log('dataArray',dataArray);
//                 const datelist = [];
//                 response.map((row) => {
//                   datelist.push({...row,
//                     Date_of_Initiation_by_MSA_Lead: row.Date_of_Initiation_by_MSA_Lead !== null ? Moment(row.Date_of_Initiation_by_MSA_Lead).format("DD-MM-YYYY") : '',  
//                   })    
//                 })
//                 setDataArray(datelist)  
//             })
//             .catch((error) => {
//                 console.error(error);
//             });
//         }
        
//              useEffect(() => {
//                 fetchData()
//             }, [])  
//             console.table('dataArray', dataArray)
            const ROW_HEIGHT = 45;
//             const [projectCount, setProjectCount] = useState(0);

//             const [rowsData, setRowsData] = useState({
//                 loading: false,
//                 data: [],
//                 filteredData: [],
//               });



              const baseDefaultColumns = [
                {
                  width: 150,
                  title: 'Ticket No.',
                  field: 'Ticket',
                  enableSearch: true,
                  enableFilter: true,
                //   render: (row) => (
                //     <Link style={{color:'#0582f7'}} to={`/ActionPlanId/${row.msaprid__proid}`}> {row.msaprid__proid}</Link>
                //   )
                },
                {
                  width: 100,
                  title: 'Name',
                  field: 'Name',
                  enableSearch: true,
                  enableFilter: true,
                  // render: (row) => (
                  //   Moment(row.Date_of_Initiation_by_MSA_Lead).format("Do MMM YYYY")
                    
            
                  // )
                  // render: (row) => {

                  //   if(row.Date_of_Initiation_by_MSA_Lead){
            
                  //    return(Moment(row.Date_of_Initiation_by_MSA_Lead).format("Do MMM YYYY"))
            
                  //   }
            
                  // }
                },
                {
                  width: 90,
                  title: 'Hrs',
                  field: 'Hrs',
                  enableSearch: true,
                  enableFilter: true,
                },
                
               
              ]
            

              // eslint-disable-next-line arrow-body-style
              const renderProjectInfoElements =() => {
               return(
                <div className={styles.container} style={{ boxSizing: 'border-box' }}>
                    <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

                  {/* <BackButton
                    action="Home"
                    handleClick={redirectToApplicationLandingPage}
                  /> */}
                  <span
                    data-testid="lastRefreshedDate"
                    className={styles.lastUpdatedAtText}
                  />
                </div>  
                <div className={styles.topDiv}> 
                {/* <div className={styles.processHeader}> */}
                        
                    {/* <div style={{ width: '40%' }}  >
                      <TabWithCount title=" Action Plan" isSelected countColor="blue" count={projectCount} />
                    </div> */}
                    {/* <div className={styles.processTopbar} > */}
                      {/* <span style={{ color: "#FFA222" }} className={styles.title}>Product Line:SCV</span> */}
                    {/* </div>
                  </div> */}
                    </div>         
                    {/*     <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

                      <BackButton
                        action="Process"
                        handleClick={redirectToApplicationLandingPage}
                      />
                      <Button variant="contained">Contained</Button>
                    </div>
                    <div className={styles.tabAndDatePickerWrapper}>
                      <div style={{ width: '15%' }}>
                        <CustomTab isSelected count={projectCount} title="Project List" />
                      </div>
                      <div style={{ 
                        width: '84%',
                        background: '#FFFFFF 0% 0% no-repeat',
                        boxShadow: '0px 3px 6px #00000029',
                        borderRadius: '4px',
                        opacity: 1 
                      }} />
                    </div> */}
                    {/* <div
                      className={styles.tableView}
                      // style={{ height: '95%', margin:'4%'}}>
                      style={{ height: '205%',margin:'0.7%' }}>
                        
                     <Table 
                        header={renderProjectInfoElements}
                        columns={[...baseDefaultColumns]}
                        defaultColumns={[...baseDefaultColumns]}
                        rowHeight={ROW_HEIGHT}
                        rows={data}
                        // primaryAction={{
                        //   name: 'Create Project',
                        //   authOperation: USER_OPERATIONS.CREATE_PROJECT,
                        //   shouldEnable: () => true,
                        //   actionFn: redirectToCreateProjectPage,
                        // }}
                        // secondaryActions={[
                                    // 	{ 
                                    // 		name: 'Edit',
                                    // 		authOperation: USER_OPERATIONS.CREATE_PROJECT,
                                    // 		shouldEnable: selected => selected.length === 1,
                                    // 		actionFn: selected => redirectToProjectEditPage(selected[0].id) ,
                                    // 	}
                                    // ]}
                        // setAsnCount={setCount}
                        // isDataLoading={rowsData.loading}
                        actionButtons
                        onRowSelect={(e)=> redirectToProjectDetailsPage(e.id)}
                      />
                 
                    </div> */}

          <TableSimple
            tableColumnData={[{"PersNo":"1234","Employee Name":"JAY","Date":"9Hrs"}]}
            tableHeaderLabel={["Ticket No.","Name","HRS"]}
            TableRowHederAling="center"
            size="small"
            headerColor="#BDBBF4"
          />
          </div>
               )
              }
                
              const loadAllProjects = async () => {
                try {
                  setRowsData(prev => ({
                    ...prev,
                    loading: true,
                  }));
            
                  const response = await API.get(
                    API_RESOURCE_URLS.PROJECTS
                  );
            
                  const { data: projectList } = response;
                  const processedProjectList = processProjectList(projectList);
            
                  setRowsData({
                    data: processedProjectList,
                    filteredData: processedProjectList,
                    loading: false,
                  });
                } catch (error) {
                  showInternalError(error);
                  console.error(buildErrorMessage(error));
                  setRowsData({
                    data: [],
                    filteredData: [],
                    loading: false,
                  });
                }
              };

            //   useAjaxCallbackWithIntervals(
            //     rowsData.loading,
            //     loadAllProjects,
            //     []
            //   );

              return (
                <>
                
                <div className={styles.container}>
          <CustomFormGroup header='OP Un-Booked Hrs -36Hrs' body={renderProjectInfoElements()} />
          
          {/* <CustomFormGroup header='Remark' body={renderRemarkElement()} /> */}
        </div>
                
                  </>
              );
            }
    //     return(
    //     <div>{Object.keys(dataArray).length !== 0 ?
    //     <div className="container-fluid">
    //         <button onClick={() => history.goBack()} type="button">Go Back</button>
    //         <form id="Frm_id1" method="POST">

    //             <div className="row mt-3">
    //                 <div className="col text-left justify-content">
    //                     {/* style="background-color: rgb(207,221,230);" */}
    //                     <h4 className="text-dark py-1" style={{ background: "#cfddf2" }} >Phygital MSA / Action Plan</h4>

    //                 </div>
    //             </div>
    //             <div className="row mb-3" style={{ height: " 450px", overflow: "auto" }} >
    //                 <div className="col-md-12">
    //                     <table className="table table-hover table-bordered " id="mytable">
    //                         {/* style="font-size: 18px;" */}
    //                         <thead className="actionPlan" style={{ fontSize: "18px" }} >
    //                             <tr>

    //                                 {/* style="text-align: center;vertical-align: middle;" */}
    //                                 <th scope="col" className="stickyheader" style={{ textAlign: "center", verticalAlign: "middle" }}>Project ID </th>
    //                                 <th scope="col" className="stickyheader" style={{ textAlign: "center", verticalAlign: "middle" }} >Action Plan Initiated Date</th>
    //                                 <th scope="col" className="stickyheader" style={{ textAlign: "center", verticalAlign: "middle" }}>Status</th>
    //                             </tr>
    //                         </thead>

    //                          <tbody>
    //                             {dataArray.map((item) => {
    //                            // console.log("item : ", item)
    //                            const InitiationDate = Moment(item.Date_of_Initiation_by_MSA_Lead).format("DD-MM-YYYY")
    //                            return(
    //                                 <tr>
    //                                 <td><Link style={{color:'#0582f7'}} to={`/ActionPlanId/${item.msaprid__proid}`}> {item.msaprid__proid}</Link></td>
    //                                 <td> {InitiationDate}</td>
    //                                 <td> {item.status_id__status}</td>
    //                             </tr>
    //                             )})}
                                

    //                         </tbody> 
    //                     </table>
    //                 </div>
    //             </div>


    //         </form>
    //     </div>
    //     : <div>Loading....</div>
    //     }</div>
    //     );
                               
    // }


    HrsTable.propTypes = {
    currentPlant: PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    }),
  };
  
//   export default connect(({ userProfile }) => ({
//     currentUserPersona: userProfile.persona,
//     userMaterialGroups: userProfile.userMaterialGroups,
//   }))(ActionPlan); 
export default HrsTable;